export interface MenuItem {
  label: string;
  icon?: string;
  path?: string;
  isInternalUrl: boolean;
  claimName: string;
  children?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  { label: 'Dashboard', icon: 'home', path: 'overview', isInternalUrl: true, claimName: 'Overview' },
  { label: 'Shipments', icon: 'list_alt', path: 'shipments', isInternalUrl: true, claimName: 'Shipments' },
  { label: 'Containers', icon: 'deployed_code', path: 'containers', isInternalUrl: true, claimName: 'Containers' },
  { label: 'Orders', icon: 'inventory', path: 'orders', isInternalUrl: true, claimName: 'Orders' },
  {
    label: 'Order Exceptions',
    icon: 'assignment_late',
    path: 'order-exceptions',
    isInternalUrl: true,
    claimName: 'OrderExceptions'
  },
  // {
  //   label: 'Vessel Schedules',
  //   icon: 'directions_boat',
  //   path: 'vessel-schedules',
  //   isInternalUrl: true,
  //   claimName: 'VesselSchedules'
  // },
  { label: 'Documents', icon: 'description', path: 'documents', isInternalUrl: true, claimName: 'Documents' },
  { label: 'How To', icon: 'live_help', path: 'how-to', isInternalUrl: true, claimName: 'Tutorials' },
  { label: 'Archive', icon: 'inventory_2', path: 'archive', isInternalUrl: true, claimName: 'Archive' },
  { label: 'Marine Portal', isInternalUrl: false, claimName: 'MarinePortal' },
  { label: 'ScanView', isInternalUrl: false, claimName: 'ScanView' },
  { label: 'ScanBook', isInternalUrl: false, claimName: 'ScanBook' },
  { label: 'Parcel & Express', isInternalUrl: false, claimName: 'ParcelExpress' },
  { label: 'ScanRate', isInternalUrl: false, claimName: 'ScanRate' },
  { label: 'ScanOms', isInternalUrl: false, claimName: 'ScanOms' },
  { label: 'ScanWMS', isInternalUrl: false, claimName: 'ScanWMS' },
  { label: 'ScanCloud', isInternalUrl: false, claimName: 'ScanCloud' },
  { label: 'Windward', isInternalUrl: false, claimName: 'Windward' },
  { label: 'Contacts', icon: 'contact_page', path: 'contact', isInternalUrl: true, claimName: 'Contact' },
  {
    label: 'Administration',
    icon: 'settings',
    isInternalUrl: true,
    claimName: 'Admin',
    children: [
      { label: 'Alerts', path: 'admin/alerts', isInternalUrl: true, claimName: 'Admin' },
      { label: 'Contacts', path: 'admin/contacts', isInternalUrl: true, claimName: 'Admin' },
      { label: 'Organisations', path: 'admin/organisations-v2', isInternalUrl: true, claimName: 'Admin' },
      { label: 'Users', path: 'admin/users', isInternalUrl: true, claimName: 'Admin' }
    ]
  }
];
